import { useEffect } from "react";
import styled from "styled-components";
import Card from "../../components/layouts/Card";
import PageWrapper from "../../components/layouts/PageWrapper";
import Spinner from "../../components/Spinner";

const AuthenticationLogoutPage = () => {
  useEffect(() => {
    localStorage.clear();
    setTimeout(() => {
      window.location.href="/";
    }, 100);
  });

  return (
    <PageWrapper>
      <AuthenticationLogoutPageWrapper>
        <Card className="logout-wrapper">
          <div className="card--title">
            <h2 className="card--title-title">Logging Out...</h2>
          </div>
          <div className="card--body">
            <Spinner size="medium" />
          </div>
        </Card>
      </AuthenticationLogoutPageWrapper>
    </PageWrapper>
  ); 
}

const AuthenticationLogoutPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > .logout-wrapper {
    width: 400px;

    & .card--title {
      text-align: center;
    }

    & .card--body {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

`;

export default AuthenticationLogoutPage;